import React from 'react';
import {BrowserRouter, Route, Routes,Navigate, useLocation } from 'react-router-dom';
import ErrorPage from 'pages/ErrorPage';
import About from 'pages/About';
import AboutWith from 'pages/AboutWith';
import HomeNew from 'pages/HomeNew';
import Sustainability from 'pages/sustainability';
import Investors from 'pages/Investor';
import ContactPage from 'pages/ContactPage';
import ThankYou from 'pages/thankYou';
import Career from 'pages/Career';
import News from 'pages/News';
import NewsDetail from 'pages/NewsDetail';
import NewsLetter from 'pages/NewsLetter';
import Utility from 'pages/Utility';
import PumpStorage from 'pages/PumpStorage';
import Footer from 'pages/Footer';
import Header from 'pages/Header';
import CommIndOnsite from 'pages/CommIndOnsite';
import CommIndOffsite from 'pages/CommIndOffsite';
import Project from 'pages/Project';
import NewsDetailPage from 'pages/NewsDetail';
import CommpDevep from 'pages/CommpDevep';
import CommunityDetailPage from 'pages/CommunityDetail';
import SolarCalculator from 'pages/solarCal';
import ScrollToHash from 'pages/ScrollHashUse';
import InvestorsWith from 'pages/InvestorWith';
import CareerWith from 'pages/CareerWith';
import SustainabilityWith from 'pages/sustainabilityWith';


const AppRoutes: React.FC = () => {
const location = useLocation();
  return (
      <>
      <Header />
      
        <Routes>
            <Route path="/" element={<HomeNew />} />
            <Route path="/home" element={<HomeNew />} />
            <Route path="/about-us"   element={<AboutWith  />} />
              <Route path="/about-us-new"   element={<About  />} />
            <Route path="/sustainability" element={<SustainabilityWith />} />
             <Route path="/sustainability-new" element={<Sustainability />} />
            <Route path="/investors" element={<InvestorsWith/>} />
              <Route path="/investors-new" element={<Investors/>} />
            <Route path="/contact-us" element={<ContactPage/>} />
            <Route path="/careers-new" element={<CareerWith />} />
                <Route path="/careers" element={<Career />} />
            <Route path="/thank-you" element={<ThankYou />} />  

            <Route path="/news" element={<News />} />
             <Route path="/news/:title" element={<NewsDetailPage />} />
            {/* //<Route  path="/news/:slug" element={<NewsDetail />}/> */}
             <Route path="/news-letter" element={<NewsLetter />} /> 
            
              <Route path="/community-development" element={<CommpDevep />} />
              <Route path="/community-development/:title" element={<CommunityDetailPage />} />

              <Route path="/calculator" element={<SolarCalculator />} />


           

              <Route path="/utility-business" element={<Utility />}/>
              <Route path="/pumped-storage" element={<PumpStorage />} />
              <Route path="/commercial-onsite" element={<CommIndOnsite />} />
              <Route path="/commercial-offsite" element={<CommIndOffsite />} />
              <Route path="/projects" element={<Project />} />
               
            <Route path="*" element={<ErrorPage />} />
        </Routes>
        
      <Footer />
      </>
  );
};

export default AppRoutes;